import { render, staticRenderFns } from "./AboutYourDappContainer.vue?vue&type=template&id=01897d24&scoped=true&"
import script from "./AboutYourDappContainer.vue?vue&type=script&lang=js&"
export * from "./AboutYourDappContainer.vue?vue&type=script&lang=js&"
import style0 from "./AboutYourDappContainer.vue?vue&type=style&index=0&id=01897d24&lang=scss&scoped=true&"
import style1 from "./AboutYourDappContainer.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01897d24",
  null
  
)

export default component.exports